import type {
  CategoryPricingConfig,
  GlobalPricingConfig,
  PriceProfile,
  PricingCategoryKey,
  PricingProfileKey,
  PricingRates,
} from './types'

export const PRICING_CATEGORIES: PricingCategoryKey[] = [
  'Notebook',
  'Desktop',
  'Servidor',
  'SSD',
  'HD',
  'NVMe',
  'Monitor',
  'Impressora',
  'Rede',
  'Serviços',
  'Software',
  'Licenças',
]

export const DEFAULT_GLOBAL_RATES: GlobalPricingConfig = {
  operationalPercent: 8,
  taxPercent: 12,
  profitPercent: 20,
  freightPercent: 0,
  otherCostsPercent: 2,
}

export const DEFAULT_CATEGORY_RATES: CategoryPricingConfig[] = PRICING_CATEGORIES.map(
  (category) => ({
    category,
    operationalPercent: DEFAULT_GLOBAL_RATES.operationalPercent,
    taxPercent: DEFAULT_GLOBAL_RATES.taxPercent,
    profitPercent:
      category === 'Serviços' || category === 'Licenças'
        ? 35
        : category === 'Notebook' || category === 'Desktop'
          ? 18
          : DEFAULT_GLOBAL_RATES.profitPercent,
  }),
)

export const DEFAULT_PROFILES: Array<Omit<PriceProfile, 'id' | 'createdAt' | 'updatedAt'>> = [
  {
    name: 'Perfil Padrão',
    key: 'default',
    operationalPercent: 8,
    taxPercent: 12,
    profitPercent: 20,
    ativo: true,
  },
  {
    name: 'Perfil Empresa',
    key: 'empresa',
    operationalPercent: 7,
    taxPercent: 12,
    profitPercent: 18,
    ativo: true,
  },
  {
    name: 'Perfil Governo',
    key: 'governo',
    operationalPercent: 6,
    taxPercent: 10,
    profitPercent: 12,
    ativo: true,
  },
  {
    name: 'Perfil Revenda',
    key: 'revenda',
    operationalPercent: 5,
    taxPercent: 12,
    profitPercent: 10,
    ativo: true,
  },
  {
    name: 'Perfil Assistência Técnica',
    key: 'assistencia',
    operationalPercent: 10,
    taxPercent: 12,
    profitPercent: 30,
    ativo: true,
  },
]

export function ratesFromProfile(profile: PriceProfile, global: GlobalPricingConfig): PricingRates {
  return {
    operationalPercent: profile.operationalPercent,
    taxPercent: profile.taxPercent,
    profitPercent: profile.profitPercent,
    freightPercent: global.freightPercent,
    otherCostsPercent: global.otherCostsPercent,
  }
}

export function mergeCategoryRates(
  base: PricingRates,
  category: string | null | undefined,
  categoryConfigs: CategoryPricingConfig[],
): PricingRates {
  if (!category) return base
  const found = categoryConfigs.find(
    (c) => c.category.toLowerCase() === category.toLowerCase(),
  )
  if (!found) return base
  return {
    ...base,
    operationalPercent: found.operationalPercent,
    taxPercent: found.taxPercent,
    profitPercent: found.profitPercent,
  }
}

export function profileKeyLabel(key: PricingProfileKey | string): string {
  const map: Record<string, string> = {
    default: 'Perfil Padrão',
    empresa: 'Perfil Empresa',
    governo: 'Perfil Governo',
    revenda: 'Perfil Revenda',
    assistencia: 'Perfil Assistência Técnica',
  }
  return map[key] ?? key
}
